import { render, staticRenderFns } from "./EventChulsuk2.vue?vue&type=template&id=1ee05520&scoped=true"
import script from "./EventChulsuk2.vue?vue&type=script&lang=js"
export * from "./EventChulsuk2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee05520",
  null
  
)

export default component.exports